import React, { useState, useEffect } from "react";
import contentfulApi from "../../utils/contentful";

import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import PageHeader from "../../components/PageHeader";
import Container from "../../components/Container";
import {Helmet} from "react-helmet";

const HipaaTraining = props => {
  const [data, setData] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    contentfulApi
      .getEntries({
        content_type: "hipaaTrainingPapaPal"
      })
      .then(response => {
        setData(Object.assign(response.items[0].fields));
        setDataLoaded(true);
      });
  }, [props]);

  if (!dataLoaded) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>{data.title} - Papa - Family On-demand</title>
      </Helmet>
    <div className="hipaa-training">
      <PageHeader>
        <h1>{data.title}</h1>
      </PageHeader>
      <Container>
        <div
          className="hipaa-training__content"
          dangerouslySetInnerHTML={{
            __html: documentToHtmlString(data.content)
          }}
        />
      </Container>
    </div>
      </>
  );
};

export default HipaaTraining;
